const KEY_CODES = {
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37,
  ENTER: 13,
  0: 48,
  9: 57,
};

export default KEY_CODES;
